import { postRequest } from "../../utils/apiHelper";
import { NativeBiometric } from "capacitor-native-biometric";
import {
  login,
  loginSuccess,
  loginFailure,
  biometricLogin,
  biometricLoginSuccess,
  biometricLoginFailure,
  enableBiometric,
  clearError,
  logout,
} from "./authSlice";

// Regular login API
export const LoginAPI = (values) => (dispatch) => {
  try {
    console.log("Hitting login");
    // dispatch(login());
    postRequest(`api/Login`, values)
      .then((res) => {
        if (res?.data?.errorResponse) {
          dispatch(loginFailure(res?.data?.errorResponse?.errorMessage));
        } else {
          dispatch(loginSuccess(res?.data));
        }
      })
      .catch((error) => {
        dispatch(loginFailure("Please enter valid credentials"));
      });
  } catch (e) {
    dispatch(loginFailure("Login failed"));
  }
};

// Biometric login - get stored credentials and call API
export const BiometricLoginAPI = () => async (dispatch) => {
  try {
    dispatch(biometricLogin());
    const storedCredentials = await NativeBiometric.getCredentials({
      server: "TechDispatch",
    });
    console.log("Hitting biologin");
    if (!storedCredentials) {
      dispatch(biometricLoginFailure("No stored credentials found"));
      return;
    }
    const loginData = {
      UserName: storedCredentials.username,
      password: storedCredentials.password,
    };
    postRequest(`api/Login`, loginData)
      .then((res) => {
        if (res?.data?.errorResponse) {
          dispatch(
            biometricLoginFailure(res?.data?.errorResponse?.errorMessage)
          );
        } else {
          dispatch(biometricLoginSuccess(res?.data));
        }
      })
      .catch((error) => {
        dispatch(biometricLoginFailure("Authentication failed"));
      });
  } catch (e) {
    dispatch(biometricLoginFailure("Biometric authentication failed"));
  }
};

// Enable biometric - save username and password
export const EnableBiometricAPI = (credentials) => async (dispatch) => {
  console.log("Hitting EnableBiometricAPI");
  try {
    await NativeBiometric.setCredentials({
      username: credentials.employeeId,
      password: credentials.password,
      server: "TechDispatch",
    });

    dispatch(enableBiometric({ enabled: true }));
  } catch (e) {
    throw e;
  }
};

// Logout API
export const LogoutAPI = () => (dispatch) => {
  try {
    const token = localStorage.getItem("token_bearer");

    if (token) {
      postRequest(`api/Logout`, {})
        .then((res) => {
          dispatch(logout());
        })
        .catch((e) => {
          dispatch(logout());
        });
    } else {
      dispatch(logout());
    }
  } catch (e) {
    dispatch(logout());
  }
};
// Forgot Password API Action
export const SendResetPasswordLinkAPI = (email) => (dispatch) => {
  return new Promise((resolve, reject) => {
    try {
      const requestData = { email };

      postRequest(`api/Accounts/SendResetPasswordLink`, requestData)
        .then((res) => {
          if (res?.data?.errorResponse) {
            reject(new Error(res.data.errorResponse.errorMessage));
          } else {
            resolve(res.data);
          }
        })
        .catch((error) => {
          reject(
            new Error(
              error?.response?.data?.Message ||
                "Failed to send password reset link"
            )
          );
        });
    } catch (e) {
      reject(new Error(e.message || "Network error occurred"));
    }
  });
};
